export default __webpack_public_path__ + "static/media/Alertas.c75e910b.svg";